const action = {
    general: 'アクションの実行中にエラーが発生しました。後でもう一度お試しください。',
    sign_in_identifier_changed: 'アクションは、この検証で使用されたサインイン識別子を変更できません。',
};
export default Object.freeze(action);
